export const checkStatus = (status) =>{
    if(status == 'ALL'){
        return "ทั้งหมด"
    }else if(status == 'Salary'){
      return "เงินเดือน"
    }else if(status == 'Position'){
      return "ตำแหน่ง"
    }else if(status == 'Manager'){
      return "ตำแหน่งทางการบริหาร"
    }else if(status == 'Education'){
      return "การศึกษา"
    }else if(status == 'Decor'){
      return "เครื่องราชอิสริยาภรณ์"
    }
}